module.exports = __webpack_public_path__ + "img/BP.b0ebfa00.png";